import { render, staticRenderFns } from "./ViewSipStatistics.vue?vue&type=template&id=51d2e6a6&scoped=true"
import script from "./ViewSipStatistics.vue?vue&type=script&lang=js"
export * from "./ViewSipStatistics.vue?vue&type=script&lang=js"
import style0 from "./ViewSipStatistics.vue?vue&type=style&index=0&id=51d2e6a6&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "51d2e6a6",
  null
  
)

export default component.exports